import React, { useState } from "react";
import {
  Box,
  useTheme,
  Popover,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { ReactComponent as FilterIcon } from "../../../../assets/icons/dashboard/perkataan/filterIcon.svg";

export default function CustomizeColumns({
  label,
  allColumns = [],
  visibleColumns = [],
  setVisibleColumns = () => {},
}) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleToggle = (key) => {
    // 🚨 Prevent toggling mandatory columns
    if (["KategoriBudaya", "Perkataan"].includes(key)) return;

    if (visibleColumns.includes(key)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== key));
    } else {
      setVisibleColumns([...visibleColumns, key]);
    }
  };

  return (
    <div>
      <Box
        onClick={handleOpen}
        display="flex"
        gap={1}
        sx={{
          alignItems: "center",
          height: "40px",
          width: "155px",
          border: 1,
          borderRadius: "5px",
          p: 1,
          backgroundColor: theme.palette.buttonHover.main,
          "&:hover": {
            backgroundColor: theme.palette.buttonHover.secondary,
          },
          cursor: "pointer",
        }}
        className="flex justify-center"
      >
        <FilterIcon
          style={{ color: theme.palette.white.main, fontSize: "16px" }}
        />
        <p
          className="font-inter font-semibold"
          style={{ fontSize: "11px", color: theme.palette.white.main }}
        >
          {label}
        </p>
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 2 }}>
          <FormGroup>
            {allColumns.map((col) => {
              const isMandatory = ["KategoriBudaya", "Perkataan"].includes(
                col.key
              );
              return (
                <FormControlLabel
                  key={col.key}
                  control={
                    <Checkbox
                      checked={visibleColumns.includes(col.key)}
                      onChange={() => handleToggle(col.key)}
                      disabled={isMandatory}
                    />
                  }
                  label={col.label}
                />
              );
            })}
          </FormGroup>
          <Button
            onClick={handleClose}
            variant="contained"
            size="small"
            sx={{ mt: 1 }}
          >
            Done
          </Button>
        </Box>
      </Popover>
    </div>
  );
}
